// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Ageg","requiredAsterisk":"Info_requiredAsterisk__inVlT"};